export default "__VITE_ASSET__953cfc60__"